import { Center, Icon, useColorModeValue } from '@chakra-ui/react'
import { LightningIcon } from '@/components/icons/LightningIcon'
import { ProtectionIcon } from '@/components/icons/ProtectionIcon'
import { ServerIcon } from '@/components/icons/ServerIcon'
import { InvoiceTypes } from '@/types/billing.interface'

interface IProps {
  type: InvoiceTypes
}

const IconType = ({ type }: IProps) => {
  const gray180_350 = useColorModeValue('gray.180', 'gray.350')
  const icon = {
    HARDWARE: ServerIcon,
    HOSTING: LightningIcon,
    PROTECTION: ProtectionIcon,
  }
  return (
    <Center
      bg={useColorModeValue('gray.180', 'whiteAlpha.200')}
      borderRadius="6px"
      boxSize={{ base: '34px', md: '34px', xl: '48px', '2xl': '64px' }}
    >
      <Icon
        color={useColorModeValue('black', 'white')}
        width={{ base: '16px', md: '14px', xl: '24px' }}
        height={{ base: '24px', md: '20px', xl: '24px' }}
        as={icon[type]}
      />
    </Center>
  )
}

export default IconType
